import React, { Suspense, useState, useEffect } from 'react'
import { Link, useParams } from "react-router-dom";
import { ReactSession } from 'react-client-session';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import InfiniteScroll from "react-infinite-scroller";
import axios from 'axios';
import LoadingBar from 'react-top-loading-bar'
import {Helmet} from "react-helmet";
import { Markup } from 'interweave';

import VideoBox from '../Global/VideoBox';
import MusicBox from '../Global/MusicBox';
import SingleGroup from '../Global/SingleGroup';
import SingleWeblink from '../Global/SingleWeblink';
import ImageBox from '../Global/ImageBox';
import Spinner from "../Global/Spinner";
import EmptyContent from '../Global/EmptyContent';

import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import Footer from '../Footer/Footer'
import styles from '../../App.module.css'
import './Profile.css'
import classes from './Profile.module.css'
import SubscribeButton from '../Global/SubscribeButton'
import MessageButton from '../Global/MessageButton'

const noAvatar = "https://hostpapasupport.com/knowledgebase/wp-content/uploads/2018/04/1-13.png";
const noCover = "https://res.cloudinary.com/omaha-code/image/upload/ar_4:3,c_fill,dpr_1.0,e_art:quartz,g_auto,h_396,q_auto:best,t_Linkedin_official,w_1584/v1561576558/mountains-1412683_1280.png";

function Profile() {
    const { uid } = useParams();
    const [user, setUser] = useState([]);
    const [address, setAddress] = useState(false);
    const [bio, setBio] = useState(false);
    const [progress, setProgress] = useState(10);
    const [tabIndex, setTabIndex] = useState(0);

    const [images, setImages] = useState([]);
    const [videos, setVideos] = useState([]);
    const [musics, setMusics] = useState([]);
    const [groups, setGroups] = useState([]);
    const [weblinks, setWeblinks] = useState([]);
    const [followers, setFollowers] = useState([]);
    const [subscribers, setSubscribers] = useState([]);

    const [hasMore, sethasMore] = useState(true);
    const [page, setPage] = useState(2);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    ReactSession.setStoreType("localStorage");
    const logged_user = ReactSession.get("logged_user");

    useEffect(() => {
        try{
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }catch(ex){}
    }, []);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/user.php?type=all&uid=${uid}`)
        .then(response => {
            setUser(response.data);
            response.data.full_address.length > 2 && setAddress(true);
            response.data.bio.length > 2 && setBio(true);

            setProgress(100);
        }).catch(error => {
            console.log(error);
        });
    }, [uid]);
    
    useEffect(() => {
        !isLoading && axios.post(`${process.env.REACT_APP_API_URL}/api/user/followers.php`, {
            uid: uid,
            limit: 5
        }, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }).then(res => {
            // console.log(res.data);
            if(res.data.message !== 'No followers found') {
                setFollowers(res.data);
                res.data.length < 8 ? sethasMore(false) : sethasMore(true);
            }
            
            setLoading(true);
            setIsLoading(true);
        }).catch(err => {
            console.log(err);
        });
    }, [uid, tabIndex]);

    useEffect(() => {
        // console.log(page);
        !isLoading && axios.post(`${process.env.REACT_APP_API_URL}/api/user/subscribers.php`, {
            uid: uid,
            limit: 5
        }, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }).then(res => {
            // console.log(res.data);
            if(res.data.message !== 'No followers found') {
                setSubscribers(res.data);
                res.data.length < 8 ? sethasMore(false) : sethasMore(true);
            }
            
            setLoading(true);
            setIsLoading(true);
        }).catch(err => {
            console.log(err);
        });
    }, [uid, tabIndex]);

    useEffect(() => {
        sethasMore(true);
        setLoading(false);
        setIsLoading(false);
        setPage(2);

        if(tabIndex === 0) {
            setProgress(100);
        }else if(tabIndex === 1) {
            FetchVideo();
            setProgress(100);
        }else if(tabIndex === 2) {
            fetchMusics();
            setProgress(100);
        }else if(tabIndex === 3) {
            fetchImages();
            setProgress(100);
        }else if(tabIndex === 4) {
            fetchGroup();
            setProgress(100);
        }else if(tabIndex === 5) {
            fetchWeblinks();
            setProgress(100);
        }

        setImages([]);
        setVideos([]);
        setMusics([]);
        setGroups([]);
        setWeblinks([]);
        setFollowers([]);
        setSubscribers([]);
    }, [tabIndex])

    const config = {
        params: {
            uid: uid,
            user_id: logged_user,
            pname: 'wesharez',
            limit: 8
        },
        headers: {
            "Content-Type": "multipart/form-data",
        }
    }

    const FetchVideo = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/videos.php?page=1&limit=8`, null, config)
            .then(response => {
                // console.log(response.data);
                if(response.data.message !== 'No videos found') {
                    setVideos(response.data);
                    response.data.length < 8 ? sethasMore(false) : sethasMore(true);
                }
                
                setLoading(true);
            }).catch(err => {
                console.log(err);
            })
    }

    const loadMoreVideos = () => {
        // console.log("loading..");
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/videos.php?page=${page}&limit=8`, null, config)
            .then(response => {
                if(response.data.message !== 'No videos found') {
                    loading && hasMore && setVideos([...videos, ...response.data]);
                    setPage(page + 1);
    
                    response.data.length < 8 ? sethasMore(false) : sethasMore(true);
                }else {
                    sethasMore(false);
                }
            }).catch(err => {
                console.log(err);
            })
    }

    const fetchImages = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/images.php?page=1`, null, config)
            .then(response => {
                if(response.data.message !== 'No images found') {
                    setImages(response.data);
                    response.data.length < 8 ? sethasMore(false) : sethasMore(true);
                }

                setLoading(true);
            }).catch(err => {
                console.log(err);
            })
    }

    const loadMoreImages = () => {
        // console.log(page);
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/images.php?page=${page}`, null, config)
            .then(response => {
                // console.log(response.data);
                if(response.data.message !== 'No images found') {
                    loading && hasMore && setImages([...images, ...response.data]);
                    setPage(page + 1);
    
                    response.data.length < 8 ? sethasMore(false) : sethasMore(true);
                }else {
                    sethasMore(false);
                }
            }).catch(err => {
                console.log(err);
            })
    }

    const fetchMusics = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/musics.php`, null, config)
            .then(response => {
                if(response.data.message !== 'No musics found') {
                    setMusics(response.data);
                    response.data.length < 8 ? sethasMore(false) : sethasMore(true);
                }

                setLoading(true);
            }).catch(err => {
                console.log(err);
            })
    }

    const loadMoreMusics = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/musics.php?page=${page}`, null, config)
            .then(response => {
                if(response.data.message !== 'No musics found') {
                    loading && hasMore && setMusics([...musics, ...response.data]);
                    setPage(page + 1);
    
                    response.data.length < 8 ? sethasMore(false) : sethasMore(true);
                }else {
                    sethasMore(false);
                }
            }).catch(err => {
                console.log(err);
            })
    }

    const fetchGroup = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/groups.php`, null, config)
            .then(response => {
                if(response.data.message !== 'No group found') {
                    setGroups(response.data);
                    response.data.length < 8 ? sethasMore(false) : sethasMore(true);
                }

                setLoading(true);
            }).catch(err => {
                console.log(err);
            })
    }

    const loadMoreGroup = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/groups.php?page=${page}`, null, config)
            .then(response => {
                if(response.data.message !== 'No group found') {
                    loading && hasMore && setGroups([...groups, ...response.data]);
                    setPage(page + 1);
    
                    response.data.length < 8 ? sethasMore(false) : sethasMore(true);
                }else {
                    sethasMore(false);
                }
            }).catch(err => {
                console.log(err);
            })
    }

    const fetchWeblinks = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/weblinks.php`, null, config)
            .then(response => {
                if(response.data.message !== 'No weblinks found') {
                    setWeblinks(response.data);
                    response.data.length < 8 ? sethasMore(false) : sethasMore(true);
                }

                setLoading(true);
            }).catch(err => {
                console.log(err);
            })
    }

    const loadMoreWebLinks = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/weblinks.php?page=${page}`, null, config)
            .then(res => {
                if(res.data.message !== 'No weblinks found') {
                    loading && hasMore && setWeblinks([...weblinks, ...res.data]);
                    setPage(page + 1);

                    res.data.length < 8 ? sethasMore(false) : sethasMore(true);
                }else {
                    sethasMore(false);
                }
            }).catch(err => {
                console.log(err);
            })
    }

    const loadMoreFollowers = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/followers.php`, {
            uid: uid,
            limit: 12,
            page: page
        }, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }).then(res => {
            if(res.data.message !== 'No followers found') {
                setFollowers([...followers, ...res.data]);
                setPage(page + 1);
                // console.log(res.data);

                res.data.length < 12 ? sethasMore(false) : sethasMore(true);
            }else {
                sethasMore(false);
            }
        }).catch(err => {
            console.log(err);
        });
    }
    const loadMoreSubscribers = () => {
        // console.log(page);
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/followers.php`, {
            uid: uid,
            limit: 12,
            page: page
        }, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }).then(res => {
            // console.log(res.data);
            if(res.data.message !== 'No subscribers found') {
                setSubscribers([...subscribers, ...res.data]);
                setPage(page + 1);
                // console.log(res.data);

                res.data.length < 12 ? sethasMore(false) : sethasMore(true);
            }else {
                sethasMore(false);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    return (
        <>
            <Helmet>
                <title>{user.name || 'Profile'} - Wesharez</title>
                <meta name="description" content={user.bio ? user.bio.replace(/<[^>]*>?/gm, '').slice(0, 270) : ''} />
                <meta name="keywords" content={user.name || ''} />
            </Helmet>
            <LoadingBar
                color='#f11946'
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />
            <Header />
            <div className={styles.main_body}>
                <Suspense fallback="<div>Please wait...</div>">
                    <Sidebar />
                </Suspense>
                <Suspense fallback="<div>Please wait...</div>">
                    <div className={styles.main_content + ` main-content`}>
                        <div className="profile-component mb-5">
                            <div className={classes.profile_header}>
                                <div className={classes.profile_hero}>
                                    <div className={classes.img}>
                                        <div className={classes.banner}>
                                            {/* <img src="https://res.cloudinary.com/omaha-code/image/upload/ar_4:3,c_fill,dpr_1.0,e_art:quartz,g_auto,h_396,q_auto:best,t_Linkedin_official,w_1584/v1561576558/mountains-1412683_1280.png" alt="" className="c-banner" /> */}
                                            <img src={user.cover_fix || ''} onError={e => {e.target.src = noCover}} alt={user.name} />
                                        </div>
                                        {
                                            uid !== logged_user && <div className={classes.button}>
                                                <Link to={`/dashboard/conversion/${uid}`}>
                                                    <MessageButton />
                                                </Link>
                                            </div>
                                        }
                                        {
                                            (user.fblink || user.twlink || user.glink || user.iglink  || user.wlink) && <div className={classes.social_icons}>
                                                <span>Social:</span>
                                                { user.fblink && user.fblink.length > 10 &&  <a href={user.fblink} target="_blank" rel="noreferrer" className={classes.fb}><i className="fa-brands fa-facebook-f"></i></a> }
                                                { user.twlink && user.twlink.length > 10 && <a href={user.twlink} target="_blank" rel="noreferrer" className={classes.tw}><i className="fa-brands fa-twitter"></i></a> }
                                                { user.glink && user.glink.length > 10 && <a href={user.glink} target="_blank" rel="noreferrer" className={classes.gp}><i className="fa-brands fa-google-plus-g"></i></a> }
                                                { user.iglink && user.iglink.length > 10 && <a href={user.iglink} target="_blank" rel="noreferrer" className={classes.ig}><i className="fa-brands fa-instagram"></i></a> }
                                                { user.wlink && user.wlink.length > 10 && <a href={user.wlink} target="_blank" rel="noreferrer" className={classes.wl}><i className="fa-solid fa-globe"></i></a> }
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.channel_details}>
                                    <div className={classes.avatar}>
                                        <a href="/">
                                            {/* <img src="https://azyrusthemes.com/CircleVideoLight/images/sv-2.png" alt="" /> */}
                                            <img src={user.avatar_fix || ''} onError={e => {e.target.src = noAvatar}} alt={user.name} />
                                        </a>
                                    </div>
                                    <div className={classes.profile_stat}>
                                        <div>
                                            <div className={classes.c_name}>
                                                <h2><Markup content={user.name}></Markup></h2>
                                            </div>
                                            <div className="subscribe_btn">
                                                <SubscribeButton uid={uid} />
                                            </div>
                                        </div>
                                        <ul className={classes.c_meta}>
                                            <li>{user.subscribers} Subscribers</li>
                                            <li>{user.shares} Shares</li>
                                            <li>{user.views} views</li>
                                            <li>{user.likes} Likes</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.profile_body}>
                                <div className={classes.profile_nav}>
                                    {/* <ul className={classes.nav_items}>
                                        <li className={classes.item + ` ` + classes.active}><a href="/">About</a></li>
                                        <li className={classes.item}><a href="/">Videos</a></li>
                                        <li className={classes.item}><a href="/">Musics</a></li>
                                        <li className={classes.item}><a href="/">Images</a></li>
                                        <li className={classes.item}><a href="/">Web groups</a></li>
                                        <li className={classes.item}><a href="/">Web pages</a></li>
                                    </ul> */}
                                    <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                                        <TabList>
                                            <Tab>About</Tab>
                                            <Tab>Videos</Tab>
                                            <Tab>Music</Tab>
                                            <Tab>Images</Tab>
                                            <Tab>Web groups</Tab>
                                            <Tab>Web pages</Tab>
                                            <Tab></Tab>
                                            <Tab></Tab>
                                        </TabList>
                                        <ins className='adsbygoogle p-4  pb-0'
                                            style={{ display: 'block' }}
                                            data-ad-client='ca-pub-8126596259429304'
                                            data-ad-slot='5153011292'
                                            data-ad-format='auto'
                                        />
                                        <div className={classes.panel_body}>
                                            <TabPanel>
                                                    <div className={`${classes.location} mb-5`}>
                                                        <p className="heading">
                                                            <i className="fa-solid fa-location-dot"></i> {address ? user.full_address : "Unknown"}
                                                        </p>
                                                        {
                                                            address && <div className={classes.google_map}>
                                                                <iframe id="map-canvas" src={`https://www.google.com/maps?q=${user.full_address}&output=embed`} target="_parent" title="google map"></iframe>
                                                            </div>
                                                        }
                                                    </div>
                                                    {
                                                        bio && <div className={`${classes.channel_description}`}>
                                                            <h5>Description</h5>
                                                            <p><Markup content={user.bio}></Markup></p>
                                                            {/* <p>Welcome to Mizael Partners Your trusted Melbourne Accounting Partner for individuals, businesses, accounting firms, SMSFs and trusts. Why We Do What We Do Our goal is add value to our client’s lives and businesses through effective accounting and business services. Business Services We offer a range of accounting, business + individual financial solutions, all designed to allow our clients to reclaim their time and grow their businesses. Business Accountant Let Mizael Partners relieve you of financial tasks so you can work on your business, not in it.</p> */}
                                                        </div>
                                                    }

                                                    {/* <img src="https://i.ytimg.com/vi/UCCBPsOesU4/maxresdefaults.jpg" alt="Img not found" onerror="this.src='https://i.insider.com/592f4169b74af41b008b5977?width=700';" /> */}


                                                    {/* <ReactImageFallback
                                                        src="https://wesharez.com/storage/media/thumbs/ed453c0e10f0b9f859ddd62a37750eb3.jpg"
                                                        fallbackImage="https://i.ytimg.com/vi/ekgUjyWe1Yc/maxresdefault.jpg"
                                                        initialImage="loader.gif"
                                                        alt="cool image should be here"
                                                        className="my-image"
                                                    /> */}
                                                    {
                                                        followers && followers.map && <div className="mt-4">
                                                            <div className={classes.divider}></div>
                                                            <h5 className={classes.user_heads}>Followed by</h5>
                                                            <ul className={classes.list_group}>
                                                                {
                                                                    followers.map((follower, index) => {
                                                                        return(
                                                                            <li className={classes.list_group_item} key={index}>
                                                                                <Link title={follower.name} to={`/profile/${follower.id}/${follower.nice_url}`}>
                                                                                    <img className={classes.avatar} src={follower.avatar} onError={e => {e.target.src = noAvatar}} alt={follower.name} />
                                                                                    <div className={classes.name}>
                                                                                        <Markup content={follower.name}></Markup>
                                                                                    </div>
                                                                                </Link>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                            <div className={classes.btn} align="center">
                                                                <button onClick={() => setTabIndex(6)} className="btn btn-light">All followers</button>
                                                            </div>
                                                        </div>
                                                    }
                                                    {
                                                        subscribers && subscribers.map && <div className="mt-4">
                                                            <div className={classes.divider}></div>
                                                            <h5 className={classes.user_heads}>Subscribed to</h5>
                                                            <ul className={classes.list_group}>
                                                                {
                                                                    subscribers.map((subscriber, index) => {
                                                                        return(
                                                                            <li className={classes.list_group_item} key={index}>
                                                                                <Link title={subscriber.name} to={`/profile/${subscriber.id}/${subscriber.nice_url}`}>
                                                                                    <img className={classes.avatar} src={subscriber.avatar} onError={e => {e.target.src = noAvatar}} alt={subscriber.name} />
                                                                                    <div className={classes.name}>
                                                                                        <Markup content={subscriber.name}></Markup>
                                                                                    </div>
                                                                                </Link>
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                            <div className={classes.btn} align="center">
                                                                <button onClick={() => setTabIndex(7)} className="btn btn-light">All subscriptions</button>
                                                            </div>
                                                        </div>
                                                    }
                                            </TabPanel>
                                            <TabPanel>
                                                <div className="row m-0">
                                                    {
                                                        videos && videos.map && videos.length > 0 ? <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={loadMoreVideos}
                                                            hasMore={hasMore}
                                                            loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                                            className='row'
                                                        >
                                                            {
                                                                videos.map((video, index) => {
                                                                    return (
                                                                        <div key={index} className="col-lg-3 col-sm-6">
                                                                            { VideoBox(video) }
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </InfiniteScroll>
                                                        : <EmptyContent />
                                                    }
                                                </div>
                                            </TabPanel>
                                            <TabPanel>
                                                <div className="row m-0">
                                                    {
                                                        musics && musics.map && musics.length > 0 ? <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={loadMoreMusics}
                                                            hasMore={hasMore}
                                                            loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                                            className='row'
                                                        >
                                                            {
                                                                musics.map((music, index) => {
                                                                    return (
                                                                        <div key={index} className="col-12">
                                                                            {
                                                                                MusicBox(music)
                                                                            }
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </InfiniteScroll>
                                                        : <EmptyContent />
                                                    }
                                                </div>
                                            </TabPanel>
                                            <TabPanel>
                                                <div className={styles.gallery}>
                                                    {
                                                        images && images.map && images.length > 0 ? <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={loadMoreImages}
                                                            hasMore={hasMore}
                                                            loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                                            className='row'
                                                        >
                                                            {
                                                                images.map((image, index) => {
                                                                    return (
                                                                        <div className={`${styles.item} col-lg-3 col-md-4 col-6 col-sm`} key={index}>
                                                                            {
                                                                                ImageBox(image)
                                                                            }
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </InfiniteScroll>
                                                        : <EmptyContent />
                                                    }
                                                </div>
                                            </TabPanel>
                                            <TabPanel>
                                                <div className={classes.groups}>
                                                    {
                                                        groups && groups.map && groups.length > 0 ? <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={loadMoreGroup}
                                                            hasMore={hasMore}
                                                            loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                                            className={classes.groups}
                                                        >
                                                            {
                                                                groups.map((group, index) => {
                                                                    return (
                                                                        <div key={index} className="col-12">
                                                                            { SingleGroup(group) }
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </InfiniteScroll>
                                                        : <EmptyContent />
                                                    }
                                                </div>
                                            </TabPanel>
                                            <TabPanel>
                                                <div className={classes.groups}>
                                                    {
                                                        weblinks && weblinks.map && weblinks.length > 0 ? <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={loadMoreWebLinks}
                                                            hasMore={hasMore}
                                                            loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                                            className={classes.groups}
                                                        >
                                                            {
                                                                weblinks.map((weblink, index) => {
                                                                    return (
                                                                        <div key={index} className="col-12">
                                                                            { SingleWeblink(weblink) }
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </InfiniteScroll>
                                                        : <EmptyContent />
                                                        
                                                    }
                                                </div>
                                            </TabPanel>
                                            <TabPanel>
                                                <div className="followers">
                                                    {
                                                        followers && followers.map && followers.length > 0 ? <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={loadMoreFollowers}
                                                            hasMore={hasMore}
                                                            loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                                            className={classes.users_list}
                                                        >
                                                            {
                                                                followers.map((follower, index) => {
                                                                    return (
                                                                        <div id={`user-${follower.id}`} className={classes.user} key={index}>
                                                                            <div className={classes.media}>
                                                                                <div className={classes.media_left}>
                                                                                    <div className={classes.avatar}>
                                                                                        <img src={follower.avatar} onError={e => {e.target.src = noAvatar}} alt={follower.name} />
                                                                                    </div>
                                                                                    <div className={classes.media_body}>
                                                                                        <h6 className={classes.media_heading}>
                                                                                            <Link to={`/profile/${follower.id}/${follower.nice_url}`}><Markup content={follower.name}></Markup></Link>                         
                                                                                        </h6>
                                                                                        <p><small> Last online: {follower.time_ago}</small></p>
                                                                                    </div>
                                                                                </div>
                                                                                <div className={classes.media_right}>
                                                                                    <SubscribeButton size="sm" uid={follower.id} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </InfiniteScroll>
                                                        : <EmptyContent />
                                                        
                                                    }
                                                </div>
                                            </TabPanel>
                                            <TabPanel>
                                            <div className="subscribers">
                                                    {
                                                        subscribers && subscribers.map && subscribers.length > 0 ? <InfiniteScroll
                                                            pageStart={0}
                                                            loadMore={loadMoreSubscribers}
                                                            hasMore={hasMore}
                                                            loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                                            className={classes.users_list}
                                                        >
                                                            {
                                                                subscribers.map((subscriber, index) => {
                                                                    return (
                                                                        <div id={`user-${subscriber.id}`} className={classes.user} key={index}>
                                                                            <div className={classes.media}>
                                                                                <div className={classes.media_left}>
                                                                                    <div className={classes.avatar}>
                                                                                        <img src={subscriber.avatar} onError={e => {e.target.src = noAvatar}} alt={subscriber.name} />
                                                                                    </div>
                                                                                    <div className={classes.media_body}>
                                                                                        <h6 className={classes.media_heading}>
                                                                                            <Link to={`/profile/${subscriber.id}/${subscriber.nice_url}`}><Markup content={subscriber.name}></Markup></Link>                         
                                                                                        </h6>
                                                                                        <p><small> Last online: {subscriber.time_ago}</small></p>
                                                                                    </div>
                                                                                </div>
                                                                                <div className={classes.media_right}>
                                                                                    <SubscribeButton size="sm" uid={subscriber.id} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </InfiniteScroll>
                                                        : <EmptyContent />
                                                        
                                                    }
                                                </div>
                                            </TabPanel>
                                        </div>
                                    </Tabs>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </Suspense>
            </div>
        </>
    )
}

export default Profile